import { clearPositionsAction } from "./positionsActions";
import { clearMessagesAction } from "./messagesActions";
import { clearChartSensorsAction } from "./chartSensorsActions";
import { clearPlayerDataAction } from "./intelligenceTimeRangePlayerActions";
import { clearMapPositionsAction } from "./mapPositionsActions";
import { clearSensorsAction } from "./sensorsActions";
import { clearMapOrigenalPositionsAction } from "./mapOrigenalPositionsAction";
import { clearMapParkingPositionsAction } from "./mapParkingPositionsActions";
import { clearMapFuelingPositionsAction } from "./mapFuelingPositionsActions";
import { clearMapDrainPositionsAction } from "./mapDrainPositionsActions";
import { clearMapGpsJammingPositionsAction } from "./mapGpsJammingPositionsActions";

const REQUEST_GET_TIMERANGE_INTELLEGENCE = "REQUEST_GET_TIMERANGE_INTELLEGENCE";
const RESPONSE_GET_TIMERANGE_INTELLEGENCE = "RESPONSE_GET_TIMERANGE_INTELLEGENCE";
const REQUEST_GET_TIMERANGE_INTELLEGENCE_FAILURE = "REQUEST_GET_TIMERANGE_INTELLEGENCE_FAILURE";
const CLEAR_INTELLIGENCE = "CLEAR_INTELLIGENCE";

const requestGetTimerangeIntellegenceAction = (data) => {
  return {
    type: REQUEST_GET_TIMERANGE_INTELLEGENCE,
    data,
  };
};

const getTimerangeIntelligence = (data) => {
  return (dispatch) => {
    dispatch(requestGetTimerangeIntellegenceAction(data));
  };
};

const responseGetTimeRangeIntelligenceAction = () => {
  return {
    type: RESPONSE_GET_TIMERANGE_INTELLEGENCE,
  };
};

const setTimeRangeIntelligenceReady = () => {
  return (dispatch) => {
    dispatch(responseGetTimeRangeIntelligenceAction());
  };
};

const requestTimeRangeIntelligenceFailureAction = () => {
  return {
    type: REQUEST_GET_TIMERANGE_INTELLEGENCE_FAILURE,
  };
};

const setTimeRangeIntelligenceFailure = () => {
  return (dispatch) => {
    dispatch(requestTimeRangeIntelligenceFailureAction());
  };
};

const resetTimeRangeIntelligence = () => {
  return (dispatch) => {
    dispatch(clearIntelligenceAction());
    dispatch(clearPositionsAction());
    dispatch(clearMessagesAction());
    dispatch(clearChartSensorsAction());
    dispatch(clearPlayerDataAction());
    dispatch(clearMapPositionsAction());
    dispatch(clearSensorsAction());
    dispatch(clearMapOrigenalPositionsAction());
    dispatch(clearMapParkingPositionsAction());
    dispatch(clearMapFuelingPositionsAction());
    dispatch(clearMapDrainPositionsAction());
    dispatch(clearMapGpsJammingPositionsAction());
  };
};

const clearIntelligenceAction = () => {
  return {
    type: CLEAR_INTELLIGENCE,
  };
};

const clearIntelligence = () => {
  return (dispatch) => {
    dispatch(clearIntelligenceAction());
    dispatch(clearPositionsAction());
    dispatch(clearMessagesAction());
    dispatch(clearChartSensorsAction());
    dispatch(clearPlayerDataAction());
    dispatch(clearMapPositionsAction());
    dispatch(clearSensorsAction());
    dispatch(clearMapOrigenalPositionsAction());
    dispatch(clearMapParkingPositionsAction());
    dispatch(clearMapFuelingPositionsAction());
    dispatch(clearMapDrainPositionsAction());
    dispatch(clearMapGpsJammingPositionsAction());
  };
};

export {
  getTimerangeIntelligence,
  setTimeRangeIntelligenceReady,
  setTimeRangeIntelligenceFailure,
  requestGetTimerangeIntellegenceAction,
  responseGetTimeRangeIntelligenceAction,
  requestTimeRangeIntelligenceFailureAction,
  REQUEST_GET_TIMERANGE_INTELLEGENCE,
  RESPONSE_GET_TIMERANGE_INTELLEGENCE,
  REQUEST_GET_TIMERANGE_INTELLEGENCE_FAILURE,
  CLEAR_INTELLIGENCE,
  resetTimeRangeIntelligence,
  clearIntelligenceAction,
  clearIntelligence,
};
